(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('CustomerCategory', CustomerCategory);

    CustomerCategory.$inject = ['$resource'];

    function CustomerCategory ($resource) {
        var resourceUrl =  'api/customer-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
